import React from 'react'
import { history } from '../store'

import PromoterStatusBadge from './PromoterStatusBadge'

import * as dateFormat from 'dateformat'

class PromoterList extends React.Component {
  goTo(number, e) {
    history.push(`/promoters/${number}`)
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Nombre</th>
              <th scope="col">Apellidos</th>
              <th scope="col">Código</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            {this.props.promoters.map(promoter => {

              return (
                <tr key={promoter.number}
                  onClick={e => this.goTo(promoter.number, e)}>
                  <th scope="row">{promoter.number}</th>
                  <td>{promoter.name}</td>
                  <td>{promoter.surname}</td>
                  <td>{promoter.password}</td>
                  <td>
                    <PromoterStatusBadge status={promoter.status} />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default PromoterList

